import {
    Component, Inject, AfterViewInit, OnDestroy, ViewChild,
    ComponentFactoryResolver, ViewContainerRef, ComponentRef
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { CustomContainerDialogData } from './container-dialog.data';
import { ContainerButtonModel } from './container-button.model';

@Component({
    selector : 'container-dialog',
    template: require('./container-dialog.component.html'),
    styles: [require('./container-dialog.component.scss')]
})
export class ContainerDialogComponent implements AfterViewInit, OnDestroy {
    public instance: any = null;

    @ViewChild('container', { read: ViewContainerRef }) private container: ViewContainerRef;
    private componentRef: ComponentRef<any>;

    constructor(
        private dialogRef: MatDialogRef<ContainerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CustomContainerDialogData,
        private resolver: ComponentFactoryResolver) {
    }

    public ngAfterViewInit() {
        const factory = this.resolver.resolveComponentFactory(this.data.component);
        this.componentRef = this.container.createComponent(factory);

        this.instance = this.componentRef.instance;
        this.data.setData(this.instance);
    }

    public ngOnDestroy() {
        if (this.componentRef) {
            this.componentRef.destroy();
        }
    }

    public onClick(button: ContainerButtonModel) {
        const innerInstance = this.instance.componentRef ? this.instance.componentRef.instance : this.instance;
        button.onClick(innerInstance, (value?: any) => this.dialogRef.close(value));
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/container-dialog/container-dialog.component.ts